import React, { useState, useEffect, useContext } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import { UserDataContext } from "context";

function TopBar({ absolute, light, isMini }) {
  const { userData, selectedOrganization } = useContext(UserDataContext);
  const userRole = userData?.isAdmin ? 'admin' : selectedOrganization?.name || 'user';
  const userName = (userData?.firstName || "User") + ' ' + (userData?.lastname || '');
  const [navbarType, setNavbarType] = useState("static");
  const [openDropdown, setOpenDropdown] = useState(null);
  const navigate = useNavigate();
  const pathname = useLocation().pathname;
  const route =
    pathname.split("/").slice(1).length > 1
      ? pathname.split("/").slice(1, -1)
      : pathname.split("/").slice(1);

  useEffect(() => {
    if (absolute) {
      setNavbarType("absolute");
    }

    const handleScroll = () => {
      if (window.scrollY === 0) {
        setNavbarType("static");
      } else {
        setNavbarType("sticky");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [absolute]);

  // Close dropdowns if clicked outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".dropdown")) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const toggleDropdown = (dropdownName) => {
    setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const handleLogOut = async () => {
    try {
      localStorage.removeItem('userEmail');
      localStorage.removeItem('token');
      localStorage.removeItem('selectedOrganization');
      navigate('/authentication/sign-in');
      window.location.reload();
    }
    catch (error) {
      console.log('Error in logout', error)
    }
  }

  return (
    <nav
      className={`${navbarType === "sticky" ? "sticky top-0" : navbarType === "absolute" ? "absolute top-0" : "static"
        } z-50 bg-white flex items-center justify-between px-4 py-3 h-16`}
    >
      {/* Left Section */}
      <div className="flex items-center gap-4">
        {/* <button
          onClick={() => setNavbarType(navbarType === "static" ? "sticky" : "static")}
          className="text-gray-600 hover:text-gray-900"
        >
          <span className="material-icons text-2xl">{isMini ? "menu_open" : "menu"}</span>
        </button> */}
        {/* Search Box */}
        {/* <div className="hidden md:block">
          <input
            type="text"
            placeholder="Search here"
            className="border border-gray-300 rounded-lg bg-[#F5F6FA] px-4 w-96 h-8 text-sm focus:ring-2 focus:ring-gray-200 focus:outline-none"
          />
        </div> */}
      </div>

      {/* Center Section */}
      {!isMini && (
        <div className="flex items-center space-x-6">
          {/* Icons */}
          <div className="flex items-center space-x-4">
            {/* <button className="text-gray-600 hover:text-gray-900 bg-[#F5F6FA] rounded-full p-2">
              <span>
                <Icon icon="icon-park-outline:brightness" className="text-xl" />
              </span>
            </button>
            <button className="text-gray-600 hover:text-gray-900 bg-[#F5F6FA] rounded-full p-2">
              <span>
                <Icon icon="mynaui:envelope" className="text-xl" />
              </span>
            </button> */}
            {/* Notification Dropdown */}
            {/* <div className="relative dropdown">
              <button
                className="relative text-gray-600 hover:text-gray-900 flex items-center bg-[#F5F6FA] rounded-full p-2"
                onClick={(e) => { e.stopPropagation(); toggleDropdown("notification"); }}
              >
                <span>
                  <Icon icon="si:notifications-alt-line" className="text-xl" />
                </span>
              </button>
              {openDropdown === "notification" && (
                <div className="absolute right-0 top-12 bg-white border border-gray-200 rounded-lg shadow-lg w-72">
                  <div className="flex flex-row items-center justify-between m-2 p-2 bg-blue-100 rounded-lg">
                    <div>Notifications</div>
                    <div className="p-1 bg-white rounded-lg">01</div>
                  </div>
                  <div className="w-full">
                    <div className="flex flex-row items-center w-full p-4 text-left hover:bg-gray-100">
                      <span className="material-icons text-green-500 mr-2">
                        <Icon icon="mdi:check-decagram-outline" />
                      </span>
                      <div>
                        <div className="text-sm font-bold">Congratulations 50+ tickets sold</div>
                        <div className="text-xs text-slate-500">Your profile has been verified</div>
                        <div className="text-xs text-slate-300">21 Messages</div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div> */}
            {/* Account Dropdown */}
            <div className="relative dropdown">
              <button
                className="relative text-gray-600 hover:text-gray-900 flex items-center bg-[#F5F6FA] rounded-full p-2"
                onClick={(e) => { e.stopPropagation(); toggleDropdown("account") }}
              >
                <span>
                  <Icon icon="codicon:account" className="text-xl" />
                </span>
              </button>

              {openDropdown === "account" && (
                <div className="fixed top-14 right-5 bg-white border border-gray-200 rounded-lg shadow-lg w-72 z-50">
                  <div className="p-2">
                    <div className="flex flex-col items-start justify-between p-4 bg-blue-100 rounded-lg">
                      <div className="font-bold">{userName}</div>
                      <div className="text-xs font-thin">{userRole}</div>
                    </div>
                    <button onClick={() => navigate('/profile')} className="flex items-center w-full p-2 text-left hover:bg-gray-100">
                      <span className="material-icons text-gray-500 mr-2">
                        <Icon icon="iconamoon:profile-light" />
                      </span>
                      My Profile
                    </button>
                    {/* <button className="flex items-center w-full p-2 text-left hover:bg-gray-100">
                      <span className="material-icons text-gray-500 mr-2">
                        <Icon icon="clarity:settings-line" />
                      </span>
                      Settings
                    </button> */}
                    <button className="flex items-center w-full p-2 text-left hover:bg-gray-100" onClick={handleLogOut}>
                      <span className="material-icons text-gray-500 mr-2">
                        <Icon icon="hugeicons:logout-04" />
                      </span>
                      Logout
                    </button>
                  </div>
                </div>
              )}
            </div>

          </div>
        </div>
      )}
    </nav>

  );
}
// Setting default values for the props of TopBar
TopBar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the TopBar
TopBar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default TopBar;
